export const GET_ESTADOS_LOADING = "get/estados/loading"
export const GET_ESTADOS_SUCCESS = "get/estados/success"
export const GET_ESTADOS_ERROR = "get/estados/error"

export const CREATE_ESTADOS_LOADING = "create/estados/loading"
export const CREATE_ESTADOS_SUCCESS = "create/estados/success"
export const CREATE_ESTADOS_ERROR = "create/estados/error"

export const UPDATE_ESTADOS_LOADING = "update/estados/loading"
export const UPDATE_ESTADOS_SUCCESS = "update/estados/success"
export const UPDATE_ESTADOS_ERROR = "update/estados/error"

export const DELETE_ESTADOS_LOADING = "delete/estados/loading"
export const DELETE_ESTADOS_SUCCESS = "delete/estados/success"
export const DELETE_ESTADOS_ERROR = "delete/estados/error"